import React, { ReactNode, useState } from 'react';
import styled from 'styled-components/macro';
import { usePopper } from 'react-popper';
import { StyledRatingSlider as RatingSlider } from './RatingSlider';
import { AdvancedModal } from './AdvancedModal';

type RatingStars = {
  userRating: number;
  rating: number;
  submitRating: () => void;
  hideLabel: boolean;
  disabled: boolean;
};

type Props = {
  className?: string;
  ratingStars: RatingStars;
  children: ReactNode;
};

export const RatingOverlay = (props: Props) => {
  const { children, ratingStars } = props;

  const [popperTriggerRef, setPopperTriggerRef] = useState<HTMLSpanElement | null>(null);
  const [popper, setPopper] = useState<HTMLDivElement | null>(null);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const { styles, update } = usePopper(popperTriggerRef, popper, {
    placement: 'bottom',
    strategy: 'fixed',
  });

  const handlePopperTriggerClick = () => {
    setPopoverVisible(!popoverVisible);
    update && update();
  };

  const handleModalTriggerClick = () => {
    setModalVisible(true);
  };

  return (
    <>
      <PopoverTrigger ref={setPopperTriggerRef} onClick={handlePopperTriggerClick}>
        {children}
      </PopoverTrigger>
      <ModalTrigger onClick={handleModalTriggerClick}>{children}</ModalTrigger>

      {popoverVisible && (
        <Popover ref={setPopper} style={styles.popper}>
          <RatingSlider
            className="rating-slider"
            userRating={ratingStars.userRating}
            submitRating={ratingStars.submitRating}
          />
        </Popover>
      )}

      <StyledModal show={modalVisible} onClose={() => setModalVisible(false)}>
        <StyledSlider
          className="rating-slider"
          userRating={ratingStars.userRating}
          submitRating={ratingStars.submitRating}
        />
      </StyledModal>
    </>
  );
};

const Popover = styled.div`
  background-color: ${(props) => props.theme.primary1};
  color: ${(props) => props.theme.primary4};
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  width: 280px;
  z-index: 10;
  border-radius: 6px;

  .rating-slider {
    margin: 42px 24px 12px;
    width: 228px;
  }
`;

const StyledSlider = styled(RatingSlider)`
  margin: 32px 12px 12px;

  .rc-slider-dot {
    background-color: #fff;
  }
`;

const StyledModal = styled(AdvancedModal)`
  width: 280px;
`;

export const PopoverTrigger = styled.span`
  cursor: pointer;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const ModalTrigger = styled.span`
  cursor: pointer;
  @media (min-width: 768px) {
    display: none;
  }
`;
